import { Badge } from '@mantine/core'
import type { FirearmBuild } from '../../app/models/build'

const VISIBILITY_META: Record<string, { label: string; color: string }> = {
  Private: { label: 'Private', color: 'red' },
  Unlisted: { label: 'Unlisted', color: 'yellow' },
  Public: { label: 'Public', color: 'green' }
}

function resolveVisibility (build: Pick<FirearmBuild, 'visibility' | 'isPublic'>): string {
  if (build.visibility) return build.visibility
  return build.isPublic === false ? 'Private' : 'Public'
}

export default function BuildVisibilityBadge ({
  build,
  size = 'xs'
}: {
  build: Pick<FirearmBuild, 'visibility' | 'isPublic'>
  size?: 'xs' | 'sm'
}) {
  const key = resolveVisibility(build)
  const meta = VISIBILITY_META[key] ?? VISIBILITY_META.Public
  return (
    <Badge size={size} variant="outline" color={meta.color} sx={{ fontFamily: 'DM Sans, sans-serif' }}>
      {meta.label}
    </Badge>
  )
}
